




















import {Component, Vue, Prop} from 'vue-property-decorator';
import {PModuleWithMeasurements} from './../../system/modules/interfaces';
import {connectionGetActiveDevices} from '@/api/configApi';
import ppingerStoreModule from '@/store/modules/entities/pmodules/ppingerStoreModule';
import Card from '@c/Card.vue';

@Component({
  components: {
    Card,
  },
})
export default class PingerModuleIpCard extends Vue {
  @Prop()
  pmodule!: PModuleWithMeasurements | null;

  socket!: WebSocket | null;

  activeDevices: string[] = [];

  async created() {
    if (this.pmodule?.guid) {
      //подключаемся к веб сокету
      this.socket = connectionGetActiveDevices(this.pmodule.guid);
      this.socket.onopen = () => {
        //отправляем action
        if (this.pmodule?.id) {
          ppingerStoreModule.processGetActiveDevicesAction({id: this.pmodule.id});
        }
      };
      this.socket.onmessage = (e: any) => this.subscribeConectionWS(e);
    }
  }

  subscribeConectionWS(e: {data: string}) {
    const strParse = JSON.parse(e.data);
    this.activeDevices = strParse.data.devices.map((x: any) => x.ip);
  }

  beforeDestroy() {
    this.closeWS();
  }

  closeWS() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }
}
